var map = {
	"./client_1.png": "c987",
	"./client_2.png": "3365",
	"./client_3.png": "07a2",
	"./client_4.png": "01e4",
	"./client_5.png": "beb1",
	"./client_6.png": "2ab4",
	"./client_7.png": "6f0c",
	"./client_8.png": "8038"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf72";